import { USER_FORM } from '@Const/forms-constants'
import { getDateFromIso } from '@App/helpers/get-date-iso-6801'
import React from 'react'
import { UserInfo } from '@Entities/user/user'
interface UserInfoSection {
    userInfo: UserInfo
}
const UserInfoSection = (props: UserInfoSection) => {
    const { userInfo } = props
    const { firstName, lastName, birthDate } = userInfo
    return (
        <section className="user-info-section">
            <h5>User Information</h5>
            <div className="fields-row-container">
                <div className="field-block">
                    <p className="small title">{USER_FORM.firstName.label}</p>
                    <p className="value">{firstName}</p>
                </div>
                <div className="field-block">
                    <p className="small title">{USER_FORM.lastName.label}</p>
                    <p className="value">{lastName}</p>
                </div>
                <div className="field-block">
                    <p className="small title">{USER_FORM.birthday.label}</p>
                    <p className="value">{birthDate ? getDateFromIso(birthDate) : ''}</p>
                </div>
            </div>
        </section>
    )
}
export default UserInfoSection
